export function optionConfig() {
  return {

    menuType: "button",
    menuWidth: 380,
    menuAlign: "center",
    align: "center",
    card: false,

    tip: false,
    lazy: false,

    tree: false,
    filterable: false,
    addBtn: false,
    editBtn: false,
    cellBtn: false,
    delBtn: false,
    selection: false,
    searchBtn: false,
    columnBtn: false,
    refreshBtn: false,
    labelWidth: 100,
    dialogWidth:'43%',

    column: [{
        label: "开户行",
        prop: "bankOpenName",
        span: 24,
        display: true,
        rules: [{
          required: true,
          message: "请输入开户行",
          trigger: "blur",
        }, ],
      },
      {
        label: "主体名称",
        prop: "bankName",
        span: 24,
        display: true,
        rules: [{
          required: true,
          message: "请输入主体名称",
          trigger: "blur",
        }, ],
      },
      {
        label: "户名",
        prop: "bankAccountName",
        span: 24,
        display: true,
        rules: [{
          required: true,
          message: "请输入户名",
          trigger: "blur",
        }, ],
      },
      {
        label: "账号",
        prop: "bankNo",
        span: 24,
        rules: [{
          required: true,
          message: "请输入主体名称",
          trigger: "blur",
        }, ],
      },
    ],
  }
}
